import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { testUrl } from "../home/BaseData";
import classes from "./AvtoreferatDissertatsiya.module.css";

const AvtoreferatDissertatsiya = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${testUrl}/api/avtoreferat-dissertatsiya/`);
        setFiles(response.data || []);
      } catch (err) {
        setError(t("errorLoadingData") || "Ma'lumotlarni yuklashda xatolik");
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, [i18n.language, t]);

  if (loading) {
    return (
      <div className={classes.container}>
        <div className={classes.loading}>{t("loading") || "Yuklanmoqda..."}</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={classes.container}>
        <div className={classes.error}>{error}</div>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h1 className={classes.title}>
          {t("avtoreferatVaDissertatsiya") || "AVTOREFERAT VA DISSERTATSIYA"}
        </h1>
      </div>

      <div className={classes.content}>
        {files.length === 0 ? (
          <div className={classes.noData}>
            {t("noFilesAvailable") || "Hozircha hech qanday fayl mavjud emas"}
          </div>
        ) : (
          <div className={classes.fileList}>
            {files.map((item) => (
              <div key={item.id} className={classes.fileItem}>
                <div className={classes.fileType}>
                  <span className={classes.typeLabel}>
                    {item.type === "avtoreferat" 
                      ? (t("avtoreferat") || "Avtoreferat")
                      : (t("dissertatsiya") || "Dissertatsiya")}
                  </span>
                </div>
                <div className={classes.fileInfo}>
                  <span className={classes.fileName}>
                    {item[`name_${i18n.language}`] || item.name_uz || item.name}
                  </span>
                </div>
                <div className={classes.fileActions}>
                  <a
                    href={item.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.downloadBtn}
                  >
                    {t("download") || "Yuklab olish"}
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AvtoreferatDissertatsiya;
